import * as yup from 'yup';

export const BrandFormSchema = yup.object().shape({
  designerName: yup.string().required({ tx: 'errors.required' }),
  title: yup.string().required({ tx: 'errors.required' }),
});
